<template>
<div class="chapter">
<div class="inner_page">
<div class="image">
<p class="image-center"><img alt="Images" src="images/P17-1.jpg"/></p>
<p class="caption">Across the country, most CCC camps were segregated. In Oregon, however, Black and white men worked and lived together. There were reportedly no problems. But when southern lawmakers heard about the mixed-race camps, they demanded they be segregated. <i>National Forest Service</i>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Page17.vue?09199742